export { default } from './RelationComponent.vue'
